module.exports = __webpack_public_path__ + "img/sweetysmart-side-logo.68d5f0a8.png";